export default "__VITE_ASSET__C4K9DdOS__"